import { STATUS_RESULT_TYPE } from '../constants/constants';

export interface IApiUserStatusData {
  RemainingLikes?: number;
  RemainingFavourites?: number;
  TimeToReset?: string;
  ResultType?: string;
  LikeCredits?: number;
  FavouriteCredits?: number;
}

export interface IApiUserStatus {
  IsMatchAccepted?: boolean;
  IsMutualFavourite?: boolean;
  IsMutualMatch?: boolean;
  UserStatus?: IApiUserStatusData;
}

export default class UserStatus {
  isMatchAccepted: boolean;
  isLikedMutualMatch: boolean;
  remainingLikes: number | null;
  remainingFavourites: number | null;
  timeToReset: string | null;
  isFavouritedMutualMatch: boolean;
  resultType: string;
  likeCredits?: number;
  favouriteCredits?: number;

  constructor() {
    this.isMatchAccepted = true;
    this.isLikedMutualMatch = false;
    this.remainingLikes = null;
    this.remainingFavourites = null;
    this.timeToReset = null;
    this.isFavouritedMutualMatch = false;
    this.resultType = STATUS_RESULT_TYPE.SEND_ALLOWED;
  }
  static mappingObject(_user: IApiUserStatus): UserStatus {
    if (_user) {
      const user = new UserStatus();
      user.isMatchAccepted = _user.IsMatchAccepted ?? true;
      user.isFavouritedMutualMatch = _user.IsMutualFavourite || false;
      user.isLikedMutualMatch = _user.IsMutualMatch || false;

      const status = _user.UserStatus || {};
      user.remainingLikes = status.RemainingLikes || 0;
      user.remainingFavourites = status.RemainingFavourites !== undefined ? status.RemainingFavourites : null;
      user.timeToReset = status.TimeToReset || null;
      user.resultType = status.ResultType || STATUS_RESULT_TYPE.SEND_ALLOWED;
      user.likeCredits = status.LikeCredits || 0;
      user.favouriteCredits = status.FavouriteCredits || 0;
      return user;
    }
    return new UserStatus();
  }

  static mappingObjects(_users: IApiUserStatus[]): UserStatus[] {
    const users: UserStatus[] = [];
    _users.forEach(_user => {
      const user = UserStatus.mappingObject(_user);
      users.push(user);
    });
    return users;
  }
}
